/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
  ],
  function(
    pip,
    pipEvents,
    window
  ){


    function initEventListeners(){

      pipEvents.b2bOnly.loginButtonClicked.off();
      pipEvents.b2bOnly.loginButtonClicked.on(function() {

        var obj = {
          category: {
            primaryCategory: "interaction"
          },
          eventInfo: {
            eventName: "pip sub-content"
          },
          subContent: {
            section: "buybox",
            component: "login to purchase",
            target: "n/a"
          }
        };

        if (pip.debugMode) {
          console.log('DDO Login to Purchase Event:', obj);
        }

        if (window.digitalData && window.digitalData.event) {
          window.digitalData.event.push(obj);
        }
      })
    }

    return {
      init: function(){
        initEventListeners();
      }
    }
  });

}.call(window));